// 閲覧履歴 ------------------------------------------------------------------------
const productId = document.getElementById("item").dataset.productId;
const time = new Date().toISOString();
const limit = 20;

for (let i = 0; i <= limit; i++) {
  if (localStorage.getItem(`history-${i}`) == productId) {
    localStorage.removeItem(`history-${i}`);
  }
}

if (localStorage.getItem(`history-${limit}`)) {
  for (let i = 0; i <= limit; i++) {
    if (i !== 0) {
      localStorage.setItem(`history-${i - 1}`, localStorage.getItem(`history-${i}`));
    }
  }
  localStorage.setItem(`history-${limit}`, productId);
} else {
  for (let i = 0; i <= limit; i++) {
    if (!localStorage.getItem(`history-${i}`)) {
      localStorage.setItem(`history-${i}`, productId);
      break;
    }
  }
}

// ----------------------------------------------------------------------------------------------------

const itemSlider = new Swiper("#itemSlider", {
  loop: true,
  slidesPerView: 1,
  pagination: {
    el: "#itemSliderPagination",
    clickable: true,
  },
});

if (window.matchMedia("(min-width: 768px)").matches) {
  document.querySelectorAll(".itemImg").forEach((element, index) => {
    const elemClass = `.swiper-pagination-bullet:nth-of-type(${index + 1})`;
    const src = element.classList.contains("itemImgMovie") ? element.querySelector("img").src : element.src;
    document.querySelector(elemClass).style.backgroundImage = document.querySelectorAll(elemClass).length && `url('${src}')`;
  });
}

document.getElementById("spOptionsSelect").addEventListener("change", function () {
  document.querySelector(".spOptionsBtn.current").classList.remove("current");
  document.getElementById(`cart-${document.getElementById("spOptionsSelect").value}`).classList.add("current");
});

if (document.querySelectorAll(".addCartBtn").length) {
  document.querySelectorAll(".addCartBtn").forEach((element) => {
    element.href = element.dataset.originalHref;
  });
}

document.querySelectorAll(".wrappingItem").forEach((element) => {
  element.addEventListener("click", function () {
    if (!element.classList.contains("current")) {
      if (element.id == "wrappingItem1") {
        if (document.querySelectorAll(".addCartBtn").length) {
          document.querySelectorAll(".addCartBtn").forEach((element) => {
            element.href = `${element.dataset.originalHref}&properties[ギフトラッピング]=通常ラッピング`;
          });
        }

        if (document.getElementById("wrappingItem2") && document.getElementById("wrappingItem2").classList.contains("current")) {
          document.getElementById("wrappingItem2").classList.remove("current");
        }

        if (document.getElementById("wrappingItem3") && document.getElementById("wrappingItem3").classList.contains("current")) {
          document.getElementById("wrappingItem3").classList.remove("current");
        }

        if (document.getElementById("wrappingItem4") && document.getElementById("wrappingItem4").classList.contains("current")) {
          document.getElementById("wrappingItem4").classList.remove("current");
        }
          
        if (document.getElementById("wrappingItem5") && document.getElementById("wrappingItem5").classList.contains("current")) {
          document.getElementById("wrappingItem5").classList.remove("current");
        }
      }

      if (element.id == "wrappingItem2") {
        if (document.querySelectorAll(".addCartBtn").length) {
          document.querySelectorAll(".addCartBtn").forEach((element) => {
            element.href = `${element.dataset.originalHref}&properties[ギフトラッピング]=SPラッピング`;
          });
        }

        if (document.getElementById("wrappingItem1") && document.getElementById("wrappingItem1").classList.contains("current")) {
          document.getElementById("wrappingItem1").classList.remove("current");
        }

        if (document.getElementById("wrappingItem3") && document.getElementById("wrappingItem3").classList.contains("current")) {
          document.getElementById("wrappingItem3").classList.remove("current");
        }

        if (document.getElementById("wrappingItem4") && document.getElementById("wrappingItem4").classList.contains("current")) {
          document.getElementById("wrappingItem4").classList.remove("current");
        }
          
        if (document.getElementById("wrappingItem5") && document.getElementById("wrappingItem5").classList.contains("current")) {
          document.getElementById("wrappingItem5").classList.remove("current");
        }
      }

      if (element.id == "wrappingItem3") {
        if (document.querySelectorAll(".addCartBtn").length) {
          document.querySelectorAll(".addCartBtn").forEach((element) => {
            element.href = `${element.dataset.originalHref}&properties[ギフトラッピング]=バレンタインラッピング`;
          });
        }

        if (document.getElementById("wrappingItem1") && document.getElementById("wrappingItem1").classList.contains("current")) {
          document.getElementById("wrappingItem1").classList.remove("current");
        }

        if (document.getElementById("wrappingItem2") && document.getElementById("wrappingItem2").classList.contains("current")) {
          document.getElementById("wrappingItem2").classList.remove("current");
        }

        if (document.getElementById("wrappingItem4") && document.getElementById("wrappingItem4").classList.contains("current")) {
          document.getElementById("wrappingItem4").classList.remove("current");
        }

        if (document.getElementById("wrappingItem5") && document.getElementById("wrappingItem5").classList.contains("current")) {
          document.getElementById("wrappingItem5").classList.remove("current");
        }
      }

      if (element.id == "wrappingItem4") {
        if (document.querySelectorAll(".addCartBtn").length) {
          document.querySelectorAll(".addCartBtn").forEach((element) => {
            element.href = `${element.dataset.originalHref}&properties[ギフトラッピング]=化粧箱ラッピング`;
          });
        }

        if (document.getElementById("wrappingItem1") && document.getElementById("wrappingItem1").classList.contains("current")) {
          document.getElementById("wrappingItem1").classList.remove("current");
        }

        if (document.getElementById("wrappingItem2") && document.getElementById("wrappingItem2").classList.contains("current")) {
          document.getElementById("wrappingItem2").classList.remove("current");
        }

        if (document.getElementById("wrappingItem3") && document.getElementById("wrappingItem3").classList.contains("current")) {
          document.getElementById("wrappingItem3").classList.remove("current");
        }

        if (document.getElementById("wrappingItem5") && document.getElementById("wrappingItem5").classList.contains("current")) {
          document.getElementById("wrappingItem5").classList.remove("current");
        }
      }

      if (element.id == "wrappingItem5") {
        if (document.querySelectorAll(".addCartBtn").length) {
          document.querySelectorAll(".addCartBtn").forEach((element) => {
            element.href = `${element.dataset.originalHref}&properties[ギフトラッピング]=革タグラッピング`;
          });
        }

        if (document.getElementById("wrappingItem1") && document.getElementById("wrappingItem1").classList.contains("current")) {
          document.getElementById("wrappingItem1").classList.remove("current");
        }

        if (document.getElementById("wrappingItem2") && document.getElementById("wrappingItem2").classList.contains("current")) {
          document.getElementById("wrappingItem2").classList.remove("current");
        }

        if (document.getElementById("wrappingItem3") && document.getElementById("wrappingItem3").classList.contains("current")) {
          document.getElementById("wrappingItem3").classList.remove("current");
        }

        if (document.getElementById("wrappingItem4") && document.getElementById("wrappingItem4").classList.contains("current")) {
          document.getElementById("wrappingItem4").classList.remove("current");
        }
      }
        
      element.classList.add("current");
    } else {
      element.classList.remove("current");
      if (document.querySelectorAll(".addCartBtn").length) {
        document.querySelectorAll(".addCartBtn").forEach((element) => {
          element.href = element.dataset.originalHref;
        });
      }
    }
  });
});

if (document.querySelectorAll(".soldoutBtn").length) {
  document.querySelectorAll(".soldoutBtn").forEach((element) => {
    element.addEventListener("click", function () {
      document.querySelector(".BIS_trigger").click();
    });
  });
}

if (document.querySelectorAll(".sizeAccordion").length) {
  document.querySelectorAll(".sizeAccordion").forEach((element) => {
    element.addEventListener("click", function () {
      const targetId = element.dataset.id;
      console.log(`.sizeAccordion.${targetId}`);

      document.querySelectorAll(`.sizeAccordionItem.${targetId}`).forEach((el) => {
        el.classList.toggle("open");
        if (el.classList.contains("open")) {
          el.style.height = `${el.scrollHeight}px`;
        } else {
          el.style.height = "0";
        }
      });
    });
  });
}
